import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import Reading from "./Reading.svg";
import { TbLabelImportantFilled } from "react-icons/tb";

const Admission = () => {
  return (
    <div
      style={{
        height: "100%",
        margin: "0",
        padding: "0",
        backgroundImage:
          "linear-gradient(90.1deg, rgba(8, 81, 98, 1) 14.5%, rgb(243, 198, 249) 135.4%)",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Navbar />

      <div className="container text-center bg-success bg-gradient rounded my-5">
        <div className="row py-5 d-flex align-items-center">
          <div className="col-md-6 text-white">
            <div className="contact_paras" style={{ marginTop: "2rem" }}>
              <p>
                Admission Criteria : Admission is taken as per availability of
                seats.
              </p>
              <p>
                Eligibility Criteria : Passed or studying in Class in the year
                preceding the admission year.
              </p>
              <p>
                <span className="text-warning">Note : </span> Any deviation from
                the specified criteria will render the candidate ineligible for
                admission, even if they have been invited to apply. In such
                cases, the school reserves the right to exercise discretion on a
                case-by-case basis to admit students who fall outside the
                prescribed age and grade brackets. The school’s decision in
                these matters will be final and binding, and no explanation will
                be provided for decisions not to admit certain candidates.
              </p>
            </div>
          </div>
          <div className="col-md-6 d-flex justify-content-center">
            <img
              src={Reading}
              alt=""
              className="img_svg"
              style={{ width: "50%" }}
              draggable="false"
            />
          </div>
        </div>
      </div>

      <div className="container bg-white p-3 rounded my-5">
        <h3 className="mb-3">
          List of Documents to be brought at the time of admission:
        </h3>
        <p>
          <span style={{ color: "green" }}>
            {" "}
            <TbLabelImportantFilled /> Transfer Certificate (TC):
          </span>{" "}
          The original TC must be submitted, countersigned by the D.E.O. or the
          concerned board official.
        </p>
        <p>
          <span style={{ color: "green" }}>
            <TbLabelImportantFilled /> Birth Certificate:{" "}
          </span>{" "}
          Original certificate for verification and one photocopy for
          submission.
        </p>
        <p>
          <span style={{ color: "green" }}>
            <TbLabelImportantFilled /> Aadhar Card :{" "}
          </span>{" "}
          Original certificate for verification and one photocopy for
          submission.
        </p>
        <p>
          <span style={{ color: "green" }}>
            <TbLabelImportantFilled /> Previous Year’s Report Card:{" "}
          </span>{" "}
          Original report card for verification and one photocopy for
          submission.
        </p>

        <p>
          <span style={{ color: "green" }}>
            <TbLabelImportantFilled /> Candidate’s Photograph:{" "}
          </span>{" "}
          Two recent passport-size photographs.
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default Admission;
